import { MouseEvent, useMemo } from 'react'
import { defineMessages, useIntl } from 'react-intl'
import { Button, Icon, Text } from '@homebotapp/hb-react-component-catalog'
import { useSelector } from 'react-redux'
import { selectCorporateProfile } from '../../../../store/selectors/customerProfile'
import { NEWREZ_COMPANY_IDS } from '../constants/NewRez'

export const MSG = defineMessages({
  send: {
    id: 'DirectMessageButton.send',
    defaultMessage: 'Send'
  }
})

export interface DirectMessageButtonProps {
  loading: boolean
  disabled: boolean
  onClick: (e: MouseEvent<HTMLButtonElement>) => void
}

export const DirectMessageButton = ({ onClick, loading, disabled }: DirectMessageButtonProps) => {
  const intl = useIntl()
  const corporateProfile = useSelector(selectCorporateProfile)
  const isNewRezClient = useMemo(() => NEWREZ_COMPANY_IDS.includes(corporateProfile?.id || ''), [corporateProfile])

  return (
    <Button
      onClick={onClick}
      colorScheme='brand'
      disabled={disabled}
      isLoading={loading}
      data-qa='directMessageButton'
      aria-label='send direct message'
      tracking={{ guid: 'kBX55EEcjw6ZZWpFsGZhQ4', ui_context: 'Direct Message', descriptor: 'Send' }}
    >
      {isNewRezClient ? <Icon name='commenting-fa' /> : <Text as='span'>{intl.formatMessage(MSG.send)}</Text>}
    </Button>
  )
}
